class bannercontroller {
    constructor(el) {
        //get the basics and start the visibility observer
        this.scroller = el; //Main element
        this.hoverblock = el.dataset.hoverblock; //Main element
        this.hoverel = null; //Main element
        this.mainimage = document.getElementById('homepage-hero-carousel__image');
        this.mainImageHolder = document.getElementById('homepage-hero-carousel');
        this.currentimage = this.mainImageHolder.style.backgroundImage;
        this.items = this.scroller.querySelector('.banner-control-items'); //Items div
        this.scrollbar = this.scroller.querySelector('.banner-control-scrollbar'); //Scrollbar
        this.scrollprogress = this.scroller.querySelector('.banner-control-progress'); //Progress block
        this.scrollnext = this.scroller.querySelector('.banner-control-next'); //Next
        this.scrollprev = this.scroller.querySelector('.banner-control-prev'); //Previous
        this.scrollerviewwidth = 0; // width of the scrollers div in the view
        this.itemswidth = 0; // total width of the items including overflow
        this.scrollbarwidth = 0; // scrollbar width
        this.progresswidth = 0; // progress
        //this.altmode = this.scroller.classList.contains('alt-mode');
        this.altmode = false; //Not to be used with this implementation
        this.debugmode = this.scroller.classList.contains('debug-mode');
        this.altscrolldist = 0;
        this.timer = null;
        this.timerstep = 3000;

        this.visibilityObserver();
    }

    // Method
    load() {
        //Load the scroller
        this.setValues();
        this.setEvents();
        this.resizeObserver();
        this.itemvisibilityObserver();
        this.scroller.classList.add('loaded');
        this.startTimer();
    }

    setValues() {
        //Sets the current values the scroller is working against
        this.scrollerviewwidth = this.scroller.offsetWidth;
        this.itemswidth = this.items.scrollWidth;
        this.scrollbarwidth = this.scrollbar.offsetWidth;
        const viewtoitems = this.scrollerviewwidth / this.itemswidth;
        this.progresswidth = this.scrollbarwidth * viewtoitems;
        this.scrollprogress.style.width = this.progresswidth + "px";
        this.maxaltscroll = this.itemswidth - (this.scrollerviewwidth / 2);
        this.altscrollrange = this.scrollbarwidth - this.progresswidth;
        if (this.hoverblock != undefined) {
            this.hoverel = document.getElementById(this.hoverblock);
        }
        if (this.debugmode) {
            this.debug();
        }
    }

    setEvents() {
        //Click events etc
        const instance = this;
        //Scroll event
        this.items.addEventListener('scroll', function () {
            requestAnimationFrame((e) => {
                instance.updateScroller();
            });
        });

        //Click to scroll
        this.scrollbar.addEventListener('click', function (e) {
            instance.updateBG();
            const target = e.target;
            const rect = target.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const perc = x / instance.scrollbarwidth;
            instance.items.scrollTo({
                top: 0,
                left: instance.itemswidth * perc,
                behavior: 'smooth'
            });
        })

        //Next
        this.scrollnext.addEventListener('click', function (e) {
            instance.nextSlide();
        })

        //Prev
        this.scrollprev.addEventListener('click', function (e) {
            instance.prevSlide();
        })
        if (this.hoverel != null) {
            // Pause timer on mouseenter
            this.hoverel.addEventListener('mouseenter', () => {
                this.stopTimer();
            });

            // Resume timer on mouseleave
            this.hoverel.addEventListener('mouseleave', () => {
                this.startTimer();
            });

            // Pause timer if touched on mobile
            this.hoverel.addEventListener('touchstart', () => {
                this.stopTimer();
            });
            //
        }
    }

    //Observers
    visibilityObserver() {
        //No point loading it unless its visible
        let el = this.scroller;
        var options = {
            root: null,
        };
        var observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!el.classList.contains('loaded')) {
                        this.load(el);
                        if (this.debugmode) {
                            this.debugconfig();
                        }
                    }
                }
            });
        }, options);
        observer.observe(el);
    }

    resizeObserver() {
        //Check if the scroller div has resized, (bootstrap mostly fixed widths in responsive so no need to trigger on viewport change)
        let el = this.scroller;
        var options = {
            root: null,
        };
        var observer = new ResizeObserver((entries, observer) => {
            this.setValues();
        }, options);
        observer.observe(el);
    }

    itemvisibilityObserver() {
        var instance = this;
        const elements = Array.from(this.items.querySelectorAll('.homepage-hero-carousel__item'));
        const options = {
            root: null, // default is viewport
            rootMargin: '0px',
            threshold: 0.5
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('active');
                    let imgsrc = entry.target.dataset.image;
                    if (imgsrc) {
                        instance.mainimage.classList.add('scrolling');
                        // Attach an onload event to the main image
                        instance.mainimage.onload = null;
                        instance.mainimage.onerror = null;
                        instance.mainimage.onload = function () {
                            instance.debug('image loaded');
                            instance.mainimage.classList.remove('scrolling');
                            setTimeout(function () {
                                instance.updateBG();
                            }, 500);
                        };

                        // Attach an onerror event to the main image
                        instance.mainimage.onerror = function () {
                            // Handle the image load error here
                            console.error('Error loading image:', imgsrc);
                        };
                        instance.mainimage.src = imgsrc;
                    }
                } else {
                    entry.target.classList.remove('active');
                }
            });
        }, options);
        elements.forEach(el => observer.observe(el));
    }

    prevSlide() {

        this.items.scrollTo({
            top: 0,
            left: this.items.scrollLeft - (this.scrollerviewwidth * 0.8),
            behavior: 'smooth'
        });
    }

    nextSlide() {

        const newScrollPosition = this.items.scrollLeft + (this.scrollerviewwidth * 0.8);
        // Reset to start if we've reached the end
        if (newScrollPosition >= (this.items.scrollWidth - this.scrollerviewwidth)) {
            this.mainimage.classList.add('restart');
            this.items.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        } else {
            this.mainimage.classList.remove('restart');
            this.items.scrollTo({
                top: 0,
                left: newScrollPosition,
                behavior: 'smooth'
            });
        }
    }

    startTimer() {
        return true;
        console.debug('start');
        this.timer = setInterval(() => {
            this.nextSlide();
        }, this.timerstep);
    }

    stopTimer() {
        return true;
        console.debug('stop');
        clearInterval(this.timer);
    }


    updateScroller() {
        let progress = (this.items.scrollLeft / this.itemswidth);
        this.scrollprogress.style.transform = 'translateX(' + (this.scrollbarwidth * progress) + 'px)';
    }

    updateBG() {
        const activeItemDiv = document.querySelector('.homepage-hero-carousel__item.active');
        if (activeItemDiv) {
            const dataImage = activeItemDiv.getAttribute('data-image');
            this.mainImageHolder.style.backgroundImage = 'url(' + dataImage + ')';
            this.debug('Background Updated');
        }
    }

    debugconfig(){
        console.table({
            'Alt Mode?': this.altmode,
            'View Width': this.scrollerviewwidth,
            'Items Width': this.itemswidth,
            'Scroll Width': this.scrollbarwidth,
            'Progress Width': this.progresswidth,
        });
    }

    debug(str) {
        if (this.debugmode) {
            console.log(str);
        }
    }
}

export default bannercontroller;
